export var Instance;
(function (Instance) {
    Instance["broadcast_node"] = "broadcast_node";
    Instance["config_manager"] = "config_manager";
    Instance["controller"] = "controller";
    Instance["driver"] = "driver";
    Instance["endpoint"] = "endpoint";
    Instance["multicast_group"] = "multicast_group";
    Instance["node"] = "node";
    Instance["utils"] = "utils";
    Instance["zniffer"] = "zniffer";
})(Instance || (Instance = {}));
